import type { MouseEvent } from 'react'
import { cn } from '@/lib/utils'

export const IMAGE_EXPAND_BTN_CLASS = 'haber-image-expand'

const EXPAND_ICON = (
  <svg
    viewBox="0 0 24 24"
    className="h-4 w-4"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M9 4H4v5" />
    <path d="M15 4h5v5" />
    <path d="M9 20H4v-5" />
    <path d="M15 20h5v-5" />
  </svg>
)

export function ImageExpandButton({
  onClick,
  label,
  className,
}: {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  label: string
  className?: string
}) {
  return (
    <button
      type="button"
      className={cn(IMAGE_EXPAND_BTN_CLASS, className)}
      aria-label={label}
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        onClick(event)
      }}
    >
      {EXPAND_ICON}
    </button>
  )
}

export function createImageExpandButtonElement(label: string): HTMLButtonElement {
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = IMAGE_EXPAND_BTN_CLASS
  btn.setAttribute('aria-label', label)
  btn.innerHTML =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 4H4v5"/><path d="M15 4h5v5"/><path d="M9 20H4v-5"/><path d="M15 20h5v-5"/></svg>'
  return btn
}
